
export const navPublicItems = [
  {
    title: 'หน้าแรก',
    icon: 'la-home',
    page: '/admission',
  },
  // {
  //   title: 'สมัครเรียน',
  //   icon: 'la-user',
  //   page: '/admission',
  // },
  // {
  //   title: 'แก้ไข/พิมพ์ใบสมัคร',
  //   icon: 'la-home',
  //   page: '/admission/dashboard',
  // },
  // { section: 'APPS', icon: 'la-ellipsis-h' },
  // {
  //   title: 'menu_registration_main',
  //   icon: 'la-users',
  //   page: '/admission',
  //   permission: []
  //   // submenu: {
  //   //   items: [
  //   //     {
  //   //       title: 'ข้อมูลนักเรียน',
  //   //       page: '/system/registration/student'
  //   //     },
  //   //   ]
  //   // }
  // },
  // {
  //   title: 'menu_goverment_main',
  //   icon: 'la-user-shield',
  //   page: '/admission',
  //   permission: [],

  // },
  // {
  //   title: 'menu_academic_main',
  //   icon: 'la-chalkboard-teacher',
  //   page: '/admission',
  //   permission: []
  // },
  // {
  //   title: 'menu_evoluation_main',
  //   icon: 'la-chart-bar',
  //   page: '/system/evoluation',
  //   permission: []
  // },
  // // {
  // //   title: 'menu_advertise_main',
  // //   icon: 'la-rss-square',
  // //   page: '/system/advertise',
  // //   permission: []
  // // },
];